const FIVE_MINUTES_IN_MS: number = 5 * 60 * 1000;

export function getTraceRetentionWindowInMS(): number {
    return FIVE_MINUTES_IN_MS;
}
